const companyData = [
  {
    date: { gr: "Μάρτιος 1991", en: "March 1991" },
    title: { gr: "Το Πρώτο Ξεκίνημα", en: "The First Beginning" },
    description: {
      gr: `Τα αδέρφια Ιωάννης και Σταύρος Τσιαούσης ξεκίνησαν σε ένα μικρό εργαστήριο, να δραστηριοποιούνται
      στο χώρο κατασκευής συστημάτων αλουμινίων και σιδηροκασκευών, στην πόλη των Σερρών. Έτσι με την
      πάροδο των χρόνων εδραιώθηκαν στον τομέα αυτόν.`,
      en: `Brothers Ioannis and Stavros Tsiaousis started in a small workshop, to be active in the field 
      of manufacturing aluminum systems and iron casings, in the city of Serres. Over the years they established 
      themselves in this field.`
    },
    image: "f11"
  },
  {
    date: { gr: "Φεβρουάριος 2003", en: "February 2003" },
    title: { gr: "Νέες Εγκαταστάσεις", en: "New Facilities" },
    description: {
      gr: `Η ανάγκη για μεγαλύτερη παραγωγή τους ώθησε στην δημιουργία ιδιόκτητων εγκαταστάσεων 1.050 τ.μ., με
      σύγχρονο και εξειδικευμένο εξοπλισμό αλλά και στην εφαρμογή εκσυγχρονισμένων μεθόδων κατασκευής.`,
      en: `The need for greater production prompted them to create privately-owned facilities of 1,050 sq.m., 
      with modern and specialized equipment and the application of modernized manufacturing methods.`
    },
    image: "f22"
  },
  {
    date: { gr: `1991 -${new Date().getFullYear()}`, en: `1991 -${new Date().getFullYear()}` },
    title: { gr: "Συνεχής Στήριξη", en: "Ongoing Support" },
    description: {
      gr: `Από την ίδρυση της εταιρείας μέχρι και σήμερα, αποκλειστικός τους συνεργάτης αποτελεί ο όμιλος
      ALUMIL που πρωταγωνιστεί στον τομέα κατασκευής συστημάτων αλουμινίου, τα οποία πληρούν όλες τις
      σύγχρονες προδιαγραφές.`,
      en: `From the establishment of the company until today, their exclusive partner is the ALUMIL group, 
      which is a leading company in the field of manufacturing aluminum systems, which meet all modern specifications.`
    },
    image: "f33"
  },
  {
    date: { gr: "Ιανουάριος 2022", en: "January 2022" },
    title: { gr: "Νέα Εποχή", en: "New era" },
    description: {
      gr: `Η επιχείρηση πλέον, έχει περάσει στα νεότερα μέλη της οικογένειας, συνδυάζοντας την εμπειρία με την
      εξέλιξη. Πρόκειται για ένα άρτια καταρτισμένο προσωπικό, με αξιόλογες πιστοποιήσεις στο ενεργητικό
      τους καθώς και αρκετές συμμετοχές σε σεμινάρια του κλάδου.`,
      en: `The business has now passed to the younger members of the family, combining experience with development. 
      This is a highly qualified staff, with valuable certifications to their credit as well as several participations in industry seminars.`
    },
    image: "f44"
  }
];

export default companyData;
